import { MockDebug } from '@tino-frontend/mocks'

import { REACT_APP_MERCHANT_BFF_API_URL } from 'constants/envs'
import { paymentPixCode } from '@fixtures/apis/payment/pix'

// Service: payment
const MockGeneratePixCode: MockDebug = {
  title: 'Generate Pix Code',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/generate-pix-code`,
  method: 'post',
  delay: 2000,
  options: [
    {
      id: 'mock-trial-validate-payment-link-valid',
      title: 'Success',
      status: 200,
      data: paymentPixCode.build(),
    },
  ],
}
export const MockDebugPayment = [MockGeneratePixCode]
